import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { API } from "../App";

const CMSContext = createContext(null);

export function CMSProvider({ children }) {
  const [settings, setSettings] = useState({
    company_name: "ISP Manager",
    company_tagline: "Internet Services Management System"
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const res = await axios.get(`${API}/public/cms`);
      setSettings(prev => ({ ...prev, ...res.data }));
    } catch (error) {
      console.error("Failed to fetch CMS settings");
    } finally {
      setLoading(false);
    }
  };

  const refreshSettings = () => {
    fetchSettings();
  };

  return (
    <CMSContext.Provider value={{ settings, loading, refreshSettings }}>
      {children}
    </CMSContext.Provider>
  );
}

export function useCMS() {
  const context = useContext(CMSContext);
  if (!context) {
    return { 
      settings: { company_name: "ISP Manager" }, 
      loading: false, 
      refreshSettings: () => {} 
    };
  }
  return context;
}

export default CMSContext;
